import { Schemas } from '~/api/gen'
import { Divider } from '~/components/elements/Divider'
import { UseItem } from './UseItem'

type Props = {
  coordinateItems: Schemas.coordinate_item_resource[]
  coordinate: Schemas.coordinate_large_with_member_shop_brands
}

export const UseItems: React.FC<Props> = ({ coordinateItems, coordinate }) => {
  return (
    <div className="flex flex-col gap-[17px] xl:gap-5  xl:bg-white xl:pb-[23px]">
      <h2 className="pl-4 pt-[6px] text-[14px] font-bold leading-none xl:pl-0 xl:pt-0 xl:text-[16px]">
        着用アイテム
      </h2>
      <ul className="flex flex-wrap px-[6px] xl:flex-col xl:gap-6 xl:px-0">
        {coordinateItems.map((coordinateItem) => {
          return (
            <li
              key={coordinateItem.id}
              className="group w-1/3 px-[10px] xl:flex xl:w-full xl:flex-col xl:gap-6 xl:px-0"
            >
              <UseItem
                coordinateItem={coordinateItem}
                coordinate={coordinate}
              />
              <div className="hidden xl:block xl:group-last:hidden">
                <Divider />
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
